import * as React from "react";

function SvgInfo({ isDarkTheme, ...props }) {
  return !isDarkTheme ? (
    <svg viewBox="64 64 896 896" focusable="false" data-icon="info-circle" fill="currentColor" aria-hidden="true" width="15" height="15">
      <path
        d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
        fill="#1890FF"
      ></path>
      <path
        d="M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
        fill="#E6F7FF"
      ></path>
      <path
        d="M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
        fill="#1890FF"
      ></path>
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path
        id="Shape"
        d="M8-24a7.947,7.947,0,0,0-5.657,2.343A7.948,7.948,0,0,0,0-16a7.947,7.947,0,0,0,2.343,5.657A7.947,7.947,0,0,0,8-8a7.948,7.948,0,0,0,5.657-2.343A7.947,7.947,0,0,0,16-16a7.948,7.948,0,0,0-2.343-5.657A7.948,7.948,0,0,0,8-24ZM8-9.125a6.836,6.836,0,0,1-2.675-.539,6.889,6.889,0,0,1-2.186-1.474,6.843,6.843,0,0,1-1.474-2.186A6.824,6.824,0,0,1,1.125-16a6.842,6.842,0,0,1,.539-2.675,6.9,6.9,0,0,1,1.474-2.186,6.843,6.843,0,0,1,2.186-1.474A6.824,6.824,0,0,1,8-22.875a6.832,6.832,0,0,1,2.675.539,6.89,6.89,0,0,1,2.186,1.473,6.848,6.848,0,0,1,1.474,2.186A6.824,6.824,0,0,1,14.875-16a6.826,6.826,0,0,1-.539,2.675,6.837,6.837,0,0,1-1.475,2.186,6.843,6.843,0,0,1-2.186,1.474A6.812,6.812,0,0,1,8-9.125ZM7.953-21.117a.563.563,0,0,0-.562.563.563.563,0,0,0,.562.562.563.563,0,0,0,.563-.562A.563.563,0,0,0,7.953-21.117Zm0,2.11h-1.5a.563.563,0,0,0-.562.562.563.563,0,0,0,.562.563h.938v4.907H6.059a.563.563,0,0,0-.563.563.563.563,0,0,0,.563.562H9.846a.563.563,0,0,0,.563-.562.563.563,0,0,0-.563-.563H8.516v-5.47A.563.563,0,0,0,7.953-19.008Z"
        transform="translate(0 24)"
        fill="#b1e1f9"
        opacity="0.774"
      />
    </svg>
  );
}

export default SvgInfo;
